import { Injectable } from '@angular/core';
import * as color from '../../config/colors';
import * as backgroundColor from "../../config/backgroundColor";
import * as toolbox from "../../config/toolbox";
import * as tooltip from "../../config/tootip";
import * as timeline from "../../config/timeline";
import * as geo from "../../config/geo";
import * as visualMaps from '../../config/visualMap';
import * as series from '../../config/series';
import * as _ from 'lodash';
import * as textStyle from '../../config/textStyle'; 
import { CommonService } from '../../service/common.service';
import { displayType } from '../timeline-map/timeline-map-interface';
import { TransformNullValuePipe } from './transform-null-value.pipe';


@Injectable({
  providedIn: 'root'
})
export class WebGLMapService {

  constructor(
    private commonService: CommonService
  ) { }

  getWebGLMapDefaultOptions(mapName: string = 'mapName') {
    let style = this.commonService.changeFontSize();
    let dimension = 2;

    let defaultOption = {
      backgroundColor: backgroundColor.backgroundColor,
      color: color.defaultColors,
      // toolbox: toolbox.getToolboxBasicMenu(),
      geo3D: geo.getGeo3D(style, mapName),
      visualMap: visualMaps.getVisualMapOfPiecewise(style, dimension),
      tooltip: tooltip.getTooltipOfPointMap(),
      series: series.getBar3DSeries(style),
      textStyle: textStyle.getTextStyle()
    }
    return defaultOption;
  }

  changeChartData(chartOptions, chartData) {
    chartData = new TransformNullValuePipe().transform(chartData)
    chartOptions.series[0].data = chartData;
  }

  // 更改visualMap
  changeVisualMap(chartOption, visualMapPosition: 'left' | 'right', visualMap, dimension: number = 2, unit: string = '') {
    let style = this.commonService.changeFontSize();

    if (!_.isEmpty(visualMap)) {
      if (visualMap.type === 'continuous') {
        chartOption.visualMap = visualMaps.getVisualMapOfContinuous(style, dimension, visualMap.data.min, visualMap.data.max);
        if (visualMap.data.hasOwnProperty('color') && visualMap.data.color.length > 0) {
          chartOption.visualMap.inRange.color = visualMap.data.color;
        }
      } else if (visualMap.type === 'piecewise') {
        if (visualMap.hasOwnProperty('data') && Array.isArray(visualMap.data)) {

          chartOption.visualMap = visualMaps.getVisualMapOfPiecewise(style, dimension, visualMap.data ,unit)

          let color = [];
          for (let i = 0; i < visualMap.data.length; i++) {
            color.push(visualMap.data[i].color);
          }
          chartOption.visualMap.inRange.color = visualMap.data.color;

        } else {
          chartOption.visualMap = visualMaps.getVisualMapOfPiecewise(style, dimension)
        }
      }
    } else {
      chartOption.visualMap = visualMaps.getVisualMapOfPiecewise(style, dimension);
    }
    this.changeVisualMapPosition(chartOption, visualMapPosition)
  }

  // 更改visualmap 维度
  changeVisualmapDimension(chartOption, dimension: number = 2) {
    chartOption.visualMap.dimension = dimension;
  }

  // 修改维度名称 
  changeDimensionNames(chartOption, dimensionNames: { [key: string]: string }[]) {
    let names = [], units = [];
    if (!dimensionNames) {
      return;
    }

    for (const iterator of dimensionNames) {
      names.push(iterator.dimensionName)
      units.push(iterator.unit)
    }

    let pointName = ['lng', 'lat'];
    pointName = pointName.concat(names);


    chartOption.series[0].dimensions = pointName;

    chartOption.tooltip = tooltip.getTooltipOfPointMap(units);
  }

  //修改visualmap位置
  changeVisualMapPosition(chartOption, position: 'left' | 'right') {
    switch (position) {
      case 'left':
        chartOption.visualMap.left = 0;
        delete chartOption.visualMap.right;
        break;
      case 'right':
        chartOption.visualMap.right = 0;
        delete chartOption.visualMap.left;
        break;
      default:
        chartOption.visualMap.left = 0;
        delete chartOption.visualMap.right;
        break;
    }
  }

  // 添加3D坐标系
  changeGeo3d(chartOption, mapName: string) {
    let style = this.commonService.changeFontSize();
    chartOption.geo3D = geo.getGeo3D(style, mapName)
  }

  changeSeries(chartOption) {
    let style = this.commonService.changeFontSize();
    chartOption.series = series.getBar3DSeries(style)
  }
}
